import { useLocation } from "react-router";

const useTituloPagina = () => {
  const location = useLocation();

  const renderSwitchTitlePage = () => {
    switch (location.pathname) {
      case "/Login":
        return "Login";
      case "/portal/Inicio":
        return "Inicio";
      case "/portal/Estudios":
        return "Estudios paciente";
      case "/portal/Turnos":
        return "Turnos paciente";
      case "/portal/Horarios":
        return "Horarios profesionales";
      case "/portal/Reservar turno":
        return "Reservar turno";
      default:
        return "Ubicacion no reconocida";
    }
  };

  const renamePage = () => {
    document.title = renderSwitchTitlePage() + " - Instituto Oftalmológico Onnis";
  };

  renamePage();
};

export default useTituloPagina;
